import React, { Component } from "react"
import { Grid, Row, Col } from "react-bootstrap"

import Card from "components/Card/Card.jsx"
import { userService } from 'helpers/user.service.jsx';
const Config = require("config")

class Settings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      kyc: false,
      api: false,
    }
  }

  componentWillMount() {
    userService.getinfo().then((data)=>{
    var user = JSON.parse(data)
    if (user.data.madmin) {
      this.setState({ api: true })
    } else {
      this.setState({ api: false })
    }
    if (user.data.kyc == "Verified") {
      this.setState({ kyc: true })
    } else {
      this.setState({ kyc: false })
    }
  })
  }

  render() {
    const { kyc, api } = this.state
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={12}>
              {" "}
              <h3>Settings</h3>{" "}
            </Col>
            <Col md={12}>
              <Card
                content={
                  <Row>
                   {api == true ? (<Col md={5}>
                      <div className="table-responsive">
                        <a href="/#/settings/accountinfo">
                          Account information
                        </a>
                        <br />
                        Update your name, address, and other contact details.
                      </div>
                    </Col>):('')}
              

                    {api == true ? (
                      <Col md={5}>
                        <div className="table-responsive">
                          {kyc == true ? (
                            <a href="/#/settings/api">API Keys</a>
                          ) : (
                            <div>
                              API Keys (You must verify your account) <br />
                              <a
                                href={Config.VerifyUrl}
                                target="_blank">
                                Verify Account
                              </a>
                            </div>
                          )}
                          <br />
                          View and create api keys.
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                        {/*       <Col md={5}>
                      <div className="table-responsive">
                        <a href="/#/settings/verify2fa">
                        2FA Authentication
                        </a>
                        <br />
                        Mobile App Authentication (2FA) secure your account with TOTP two-factor authentication.
                      </div>
                    </Col> */}
              

                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default Settings
